import _t from 'i18n!nls/front-page';

export const getPopularAndTrendingCollectionData = () => {
  return {
    headline: _t('Trending courses'),
    collections: [
      {
        headline: _t('Most popular'),
        headlineTarget: '/explore/most-popular-courses',
        collection: {
          id: 'most-popular',
          collectionModuleId: 'most-popular-filter',
          collectionName: 'All',
          facets: [['topic:Business', 'topic:Data Science', 'topic:Information Technology', 'topic:Computer Science']],
        },
      },
      {
        headline: _t('Weekly spotlight'),
        headlineTarget:
          '/search?partners=Amazon Web Services&partners=Arizona State University&partners=Google&partners=Google Cloud&partners=HRCI&partners=IBM&partners=Intuit&partners=Johns Hopkins University&partners=Macquarie University&partners=Meta&partners=Microsoft&partners=Packt&partners=Stanford University&partners=University of California%2C Davis&partners=University of California%2C Irvine&partners=University of Colorado Boulder&partners=University of Illinois Urbana-Champaign&partners=University of Pennsylvania&partners=Vanderbilt University&partners=Yale University&sortBy=NEW',
        collection: {
          id: 'trending-now',
          collectionModuleId: 'promo-template-preset-collection',
          presetCollectionId: 'UooUV9q7TxWuOqFbpsHCKQ',
        },
      },
      {
        headline: _t('In-demand AI skills'),
        headlineTarget: '/explore/generative-ai',
        collection: {
          id: 'in-demand-ai-skills',
          collectionModuleId: 'promo-template-preset-collection',
          presetCollectionId: 'ZEF0X29xSIOE_s-kixzF2Q',
        },
      },
    ],
  };
};

export const getPopularByCategoryCollectionData = () => {
  return {
    headline: _t('Most popular by category'),
    collections: [
      {
        headline: _t('Popular in Business'),
        headlineTarget: '/browse/business',
        collection: {
          id: 'popular-in-business',
          collectionModuleId: 'most-popular-filter',
          collectionName: 'Business',
          facets: [['topic:Business']],
        },
      },
      {
        headline: _t('Popular in Data'),
        headlineTarget: '/browse/data-science',
        collection: {
          id: 'popular-in-data',
          collectionModuleId: 'most-popular-filter',
          collectionName: 'Data Science',
          facets: [['topic:Data Science']],
        },
      },
      {
        headline: _t('Popular in Tech'),
        headlineTarget: '/browse/computer-science',
        collection: {
          id: 'popular-in-tech',
          collectionModuleId: 'most-popular-filter',
          collectionName: 'Computer Science',
          facets: [['topic:Computer Science']],
        },
      },
    ],
  };
};
